import { useEffect } from "react";

import { useHistory } from "react-router-dom";

import { useUserMedia } from "../../hooks/useUserMedia";

export default function useRouteEffects({ store, inMeetingDetailsRoute, nonIdSubPaths }) {
  const history = useHistory();
  const { stopPreviewStream } = useUserMedia();

  useEffect(() => {
    const reloaded = sessionStorage.getItem("reloaded");
    if (!reloaded) {
      sessionStorage.setItem("reloaded", "true");
    } else {
      console.log("Page was reloaded");
      if (store.isJoined) {
        store.updateJoinedState(false);
        store.clearJoinProgress();
      }
    }

    const handleRouteChange = (location) => {
      const isMeetingDetailsRoute = location.pathname.startsWith("/live/") && !nonIdSubPaths.includes(location.pathname.split("/live/")[1]);
      const isLeavingMeetingDetailsRoute = !isMeetingDetailsRoute && inMeetingDetailsRoute;

      if (isLeavingMeetingDetailsRoute) {
        if (!store.isJoined && store.meeting.status === "started" && !store.userMediaPermissionsGranted) {
          console.log("Resetting meeting details store due to route change.");
          store.reset();
          store.clearPersistedData();
        }
        if (store.meeting?.status === "starting") {
          console.log('Return to the /live from meeting?.status === "starting". Reset store');
          store.reset();
          store.clearPersistedData();
        }
      }

      if (store.joinError && !isMeetingDetailsRoute) {
        console.log("Resetting store due to join error and leaving meeting details route.");
        store.reset();
        stopPreviewStream();
      }
    };

    const unlisten = history.listen(handleRouteChange);

    return () => {
      sessionStorage.removeItem("reloaded");
      unlisten();
    };
  }, [history, inMeetingDetailsRoute, store]);
}
